(() => {
  'use strict';

  const CONFIG_SELECTOR = '#ayla-tailoring-config';
  const PRODUCT_FORM_SELECTOR = 'form[action*="/cart/add"]';

  function shopRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function getConfig() {
    return document.querySelector(CONFIG_SELECTOR);
  }

  function getProductSection(config) {
    return config.closest('[id^="shopify-section-"]') || document;
  }

  function collectLineItemProperties(formData) {
    const properties = {};

    for (const [name, rawValue] of formData.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);

      if (!match) continue;

      const value = String(rawValue).trim();

      if (value) {
        properties[match[1]] = value;
      }
    }

    return properties;
  }

  function tailoringSelected(properties) {
  return Object.entries(properties).some(([name, value]) => {
    const propertyName = String(name)
      .trim()
      .toLowerCase()
      .replace(/\?/g, '');

    const propertyValue = String(value)
      .trim()
      .toLowerCase();

    const isTailoringField =
      propertyName === 'custom tailoring' ||
      propertyName === 'add tailoring';

    return (
      isTailoringField &&
      propertyValue.startsWith('yes')
    );
  });
}

  function productTitle(section) {
    const heading =
      section.querySelector('h1') ||
      document.querySelector('main h1');

    return (
      heading?.textContent?.replace(/\s+/g, ' ').trim() ||
      'Selected outfit'
    );
  }

  function findProductForm(section, submittedForm) {
    if (
      submittedForm instanceof HTMLFormElement &&
      submittedForm.matches(PRODUCT_FORM_SELECTOR) &&
      section.contains(submittedForm)
    ) {
      return submittedForm;
    }

    return Array.from(
      section.querySelectorAll(PRODUCT_FORM_SELECTOR)
    ).find((form) => {
      return (
        form.querySelector('[name="id"]') &&
        form.querySelector('[type="submit"]')
      );
    });
  }

  async function handleSubmit(event) {
    const config = getConfig();

    if (!config) return;

    const section = getProductSection(config);
    const form = findProductForm(section, event.target);

    if (!form || event.target !== form) return;

    const formData = new FormData(form);
    const properties = collectLineItemProperties(formData);

    // Normal order ho to Pipeline ka original cart system chalega.
    if (!tailoringSelected(properties)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.aylaTailoringSubmitting === 'true') {
      return;
    }

    const productVariantId = Number(formData.get('id'));
    const serviceVariantId = Number(
      config.dataset.serviceVariantId
    );

    const quantity = Math.max(
      1,
      Number.parseInt(formData.get('quantity') || '1', 10) || 1
    );

    if (!productVariantId || !serviceVariantId) {
      window.alert(
        'Custom tailoring could not be added. Please refresh and try again.'
      );
      return;
    }

    const submitButton = form.querySelector('[type="submit"]');

    form.dataset.aylaTailoringSubmitting = 'true';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    const mainItem = {
      id: productVariantId,
      quantity,
      properties
    };

    const sellingPlan = formData.get('selling_plan');

    if (sellingPlan) {
      mainItem.selling_plan = Number(sellingPlan);
    }

    const serviceItem = {
  id: serviceVariantId,
  quantity,
  parent_id: productVariantId,
  properties: {
    'Tailoring for': productTitle(section)
  }
};

    try {
      const response = await fetch(
        `${shopRoot()}cart/add.js`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [mainItem, serviceItem]
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'The items could not be added.'
        );
      }

      window.location.assign(`${shopRoot()}cart`);
    } catch (error) {
      console.error('Aylaa tailoring add-on:', error);

      form.dataset.aylaTailoringSubmitting = 'false';

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }

      window.alert(
        error.message ||
        'Custom tailoring could not be added. Please try again.'
      );
    }
  }

  function hideAcceleratedCheckout() {
    const config = getConfig();

    if (!config) return;

    const section = getProductSection(config);

    section
      .querySelectorAll('.shopify-payment-button')
      .forEach((button) => {
        button.hidden = true;
      });
  }

  document.addEventListener('submit', handleSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      hideAcceleratedCheckout,
      { once: true }
    );
  } else {
    hideAcceleratedCheckout();
  }

  document.addEventListener(
    'shopify:section:load',
    hideAcceleratedCheckout
  );
  function findAylaTailoringDropdown(section) {
    return Array.from(section.querySelectorAll('select')).find(
      (select) => {
        const optionTexts = Array.from(select.options).map(
          (option) =>
            String(option.textContent)
              .trim()
              .toLowerCase()
        );

        return (
          optionTexts.some((text) =>
            text.includes('tailor this creation')
          ) &&
          optionTexts.some((text) =>
            text.includes('continue without tailoring')
          )
        );
      }
    );
  }

  function readPriceFromButton(button) {
    const prices = String(button.textContent).match(
      /\d[\d,]*(?:\.\d{1,2})?/g
    );

    if (!prices?.length) return null;

    return Number(
      prices[prices.length - 1].replace(/,/g, '')
    );
  }

  function formatAedPrice(price) {
    return new Intl.NumberFormat('en-AE', {
      maximumFractionDigits: 2
    }).format(price);
  }

  function updateAylaTailoringDisplay() {
    const config = getConfig();

    if (!config) return;

    const section = getProductSection(config);
    const dropdown = findAylaTailoringDropdown(section);
    const form = section.querySelector(PRODUCT_FORM_SELECTOR);
    const addButton = form?.querySelector('[type="submit"]');

    if (!dropdown || !addButton) return;

    if (!addButton.dataset.aylaBasePrice) {
      const basePrice = readPriceFromButton(addButton);

      if (!basePrice) return;

      addButton.dataset.aylaBasePrice = String(basePrice);
      addButton.dataset.aylaBaseText =
        addButton.textContent.trim();
    }

    const selectedText = String(
      dropdown.options[dropdown.selectedIndex]?.textContent || ''
    )
      .trim()
      .toLowerCase();

    const hasTailoring = selectedText.startsWith('yes');
    const basePrice = Number(addButton.dataset.aylaBasePrice);
    const displayedPrice = basePrice + (hasTailoring ? 150 : 0);

    const originalText =
      addButton.dataset.aylaBaseText || 'ADD TO CART';

    const buttonTitle =
      originalText.split('•')[0].trim() || 'ADD TO CART';

    addButton.textContent =
      `${buttonTitle} • AED ${formatAedPrice(displayedPrice)}`;

    /*
     * Free Globo plan background workaround:
     * Find the nearest wrapper containing the option fields.
     */
    let panel = dropdown.parentElement;

    while (panel && panel !== section) {
      const fieldCount = panel.querySelectorAll(
        'input, select, textarea'
      ).length;

      if (fieldCount >= 3) {
        panel.style.setProperty(
          'background-color',
          'transparent',
          'important'
        );

        panel.style.setProperty(
          'box-shadow',
          'none',
          'important'
        );

        break;
      }

      panel = panel.parentElement;
    }
  }

  function initialiseAylaTailoringDisplay() {
    [0, 300, 800, 1500].forEach((delay) => {
      window.setTimeout(updateAylaTailoringDisplay, delay);
    });
  }

  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLSelectElement) {
      window.setTimeout(updateAylaTailoringDisplay, 0);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAylaTailoringDisplay,
      { once: true }
    );
  } else {
    initialiseAylaTailoringDisplay();
  }

  document.addEventListener(
    'shopify:section:load',
    initialiseAylaTailoringDisplay
  );
  })();